module.exports = __webpack_public_path__ + "img/icon-warning-forestfire-yellow.847bdb9e.svg";